export default "__VITE_ASSET__D6bqm6Cu__"